import { useEffect } from "react";
import {
    registerReconnectHandler,
    SignalRReconnectEvent,
} from "@/services/notificationSignalR";

export function useSignalRReconnect(
    handler: (event: SignalRReconnectEvent) => void,
    handlerName: string = "SignalRReconnectHandler"
) {
    useEffect(() => {
        return registerReconnectHandler(handlerName, handler);
    }, [handler, handlerName]);
}
